import { Component, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ThemeElevated } from '@frontend/sports/common/ui/shared';
import { AccordionVariant, SportsThemedAccordionDirective } from '@frontend/sports/common/ui/sports-themed-accordion';
import { SportsThemedCardDirective } from '@frontend/sports/common/ui/sports-themed-card';
import { WidgetComponent } from '@frontend/sports/widget/core/feature';
import { DsAccordionModule } from '@frontend/ui/accordion';
import { DsCard } from '@frontend/ui/card';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { MiniGamesTrackingService } from './minigames-tracking.service';
import { MinigamesComponent } from './minigames.component';
import { MiniGamesService } from './minigames.service';
import { MiniGamesWidgetCollapsedEvent, MiniGamesWidgetExpandedEvent } from './sports.event';

@Component({
    selector: 'ms-minigames-column',
    templateUrl: './minigames-column.component.html',
    styleUrl: './minigames-column.component.scss',
    providers: [MiniGamesService, MiniGamesTrackingService],
    imports: [MinigamesComponent, DsCard, DsAccordionModule, IconCustomComponent, SportsThemedAccordionDirective, SportsThemedCardDirective],
    host: {
        class: 'mini-games-var-scope',
    },
})
export class MinigamesColumnComponent extends WidgetComponent<never> {
    collapsed = false;
    @ViewChild(MinigamesComponent) minigamesComponent?: MinigamesComponent;
    areMiniGamesEnabled: boolean;
    themedAccordionVariant: AccordionVariant;

    public readonly sitecore = inject(Sitecore);
    private readonly miniGamesService = inject(MiniGamesService);

    constructor() {
        super();
        this.miniGamesService.miniGamesEnabled.pipe(takeUntilDestroyed()).subscribe((resp) => {
            this.areMiniGamesEnabled = resp;
        });
        this.themedAccordionVariant = {
            'sportingbet-br': 'surface-low',
            'mgm-dice': 'surface-low',
            'bwin-dark': 'surface-low',
            'sports-interaction': 'surface-highest',
        };
    }

    themeElevated: ThemeElevated = {
        'sportingbet-br': { isElevated: false },
        'betboo-br': { isElevated: false },
    };

    panelToggled(): void {
        this.collapsed = !this.collapsed;

        if (!this.minigamesComponent) {
            return;
        }

        const event = this.collapsed ? new MiniGamesWidgetCollapsedEvent() : new MiniGamesWidgetExpandedEvent();
        this.miniGamesService.postEventsToCasino(event, this.minigamesComponent.casinoIframe);
    }
}
